import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModulePermissionStore } from '../shared/store/modulePerm.store';
import { ModulePermissionElement } from '../shared/Models/ModulePermission.model';
import { AppUserService } from '../Services/ApplicationServices/AppUserService';


// export interface RouteInfo {
//     path: string;
//     title: string;
//     icon: string;
//     class: string;
// }

export const ROUTES = [

    { path: '/admin/dashboard', title: 'Dashboard', icon: 'nc-bank', class: '' },
 
      ////////////  Master    master-userentries ////////////////////
       { path: '/admin/user-registration', title: 'User Registration', icon: 'nc-bank', class: '' },   
       { path: '/admin/product-entries', title: 'Product Entries', icon: 'nc-bank', class: '' },   
       { path: '/admin/consignor-registration', title: 'Consignor Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/consignee-registration', title: 'Consignee Entries', icon: 'nc-bank', class: '' },
       
       // { path: '/admin/pointscoupon-entries', title: 'PointsCoupon Rule Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/pointscoupon-entries?type=COUPON', title: 'Coupon Rule Entries', icon: 'nc-bank', class: '' },   
       { path: '/admin/pointscoupon-entries?type=EARNINGPOINTS', title: 'EarningPoints Rule Entries', icon: 'nc-bank', class: '' },   
       { path: '/admin/pointscoupon-entries?type=REDEEMPOINTS', title: 'RedeemPoints Rule Entries', icon: 'nc-bank', class: '' },      
       

       //{ path: '/admin/accountledger-entries', title: 'Account Ledger Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=DEBTOR&cat=2&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Debtor Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=CREDITOR&cat=3&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Creditor Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=EMPLOYEE&cat=4&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Employee Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=HOSPITAL%20AND%20DOCTOR&cat=8&ck_assomr=false&ck_dr=true&ck_demo=true', title: 'Doctor Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=ASSOCIATE&cat=9&ck_assomr=true&ck_dr=false&ck_demo=true', title: 'Associate Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=BANK&cat=5&ck_assomr=false&ck_dr=false&ck_demo=false', title: 'Bank Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=INSURANCE%20ORG&cat=19&ck_assomr=false&ck_dr=false&ck_demo=false', title: 'TPA / Insurance Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=EXPENSE&cat=7&ck_assomr=false&ck_dr=false&ck_demo=false', title: 'Expense Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/accountledger-entries?type=INCOME&cat=6&ck_assomr=false&ck_dr=false&ck_demo=false', title: 'Income Entries', icon: 'nc-bank', class: '' },

       
    
       //////////////////  Entry Panel  entries-accountingbook ////////////
       //{ path: '/admin/entries-accountingbook', title: 'AccountingBook Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/entries-accountingbook?type=SalesRegister', title: 'Sales Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/entries-accountingbook?type=PurchaseRegister', title: 'Purchase Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/entries-accountingbook?type=RequisitionRegister', title: 'Requisition Entries', icon: 'nc-bank', class: '' },
       { path: '/admin/entries-accountingbook?type=DayBookRegister', title: 'DayBook Entries', icon: 'nc-bank', class: '' },



       { path: '/admin/entries-registration', title: 'Registration Entries', icon: 'nc-bank', class: '' },        
       { path: '/admin/activityevent-active', title: 'Activity Active', icon: 'nc-bank', class: '' },

       //{ path: '/admin/activityevent-entries', title: 'Activity Entries', icon: 'nc-bank', class: '' }, 
       { path: '/admin/activityevent-entries?type=INQUIRER&cat=10&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Inquirer Entries', icon: 'nc-bank', class: '' }, 
       { path: '/admin/activityevent-entries?type=APPOINTMENT&cat=11&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Appointment Entries', icon: 'nc-bank', class: '' }, 
       { path: '/admin/activityevent-entries?type=QUEUE&cat=12&ck_assomr=false&ck_dr=false&ck_demo=true', title: 'Queue Entries', icon: 'nc-bank', class: '' }, 
     

       { path: '/admin/loan-registration', title: 'Loan Registration', icon: 'nc-bank', class: '' }, 
       { path: '/admin/loan-lifecycle', title: 'Loan LifeCycle', icon: 'nc-bank', class: '' }, 
       { path: '/admin/loan-repayment', title: 'Loan Payment', icon: 'nc-bank', class: '' }, 
       { path: '/admin/loan-report', title: 'Loan Report', icon: 'nc-bank', class: '' },

       { path: '/admin/PurchaseBookPayment', title: 'Purchase Payment', icon: 'nc-bank', class: '' },    

       { path: '/admin/requisitionlist-redeempoints', title: 'Dashboard', icon: 'nc-bank', class: '' },

       { path: '/admin/Ledgerprivacysetup',  title: 'Ledger Privacy', icon: 'nc-bank', class: '' },
        
    
       ///////////   Report & Export    report-userperformance /////////////////
       { path: '/admin/statistics-userperformance', title: 'Statistics Performance', icon: 'nc-bank', class: '' },
       { path: '/admin/statistics-admissionlisted', title: 'Statistics Admission', icon: 'nc-bank', class: '' },
       { path: '/admin/statistics-stock', title: 'Statistics Stock', icon: 'nc-bank', class: '' },
       { path: '/admin/statistics-deleted', title: 'Statistics Deleted', icon: 'nc-bank', class: '' },
      
        // { path: '/admin/statistics-bill', title: 'Statistics Bill', icon: 'nc-bank', class: '' },  
        { path: '/admin/statistics-bill?type=DayBookRegister', title: 'DayBook Search', icon: 'nc-bank', class: '' }, 
        { path: '/admin/statistics-bill?type=SalesRegister', title: 'Sales Search', icon: 'nc-bank', class: '' }, 
        { path: '/admin/statistics-bill?type=PurchaseRegister', title: 'Purchase Search', icon: 'nc-bank', class: '' }, 
        { path: '/admin/entries-accountingbook?type=RequisitionRegister', title: 'Requisition Search', icon: 'nc-bank', class: '' },  
       
        { path: '/admin/generate-attendancesheet', title: 'Attendance Sheet', icon: 'nc-bank', class: '' },
        { path: '/admin/generate-attendancesheetNEW', title: 'Attendance Sheet New', icon: 'nc-bank', class: '' },    
        { path: '/admin/DaybookStatistics', title: 'Statistics Daybook', icon: 'nc-bank', class: '' },
      
          
       //////////////////  Print   print-idcard   ///////////////////
       { path: '/admin/generate-idcard', title: 'Generate Id Card', icon: 'nc-bank', class: '' },
       { path: '/admin/generate-taxinvoice', title: 'Generate Tax Invoice', icon: 'nc-bank', class: '' },   
       { path: '/admin/daybookstatistics-datewise-list', title: 'Daybook DateWise', icon: 'nc-bank', class: '' },
       


      


];

@Component({
    moduleId: module.id,
    selector: 'angular-sidebar-cmp',
    templateUrl: 'angular-sidebar.component.html',
    providers: [AppUserService],
    styleUrls: ['angular-sidebar.component.scss'],
})

export class AngularSidebarComponent implements OnChanges {

    @Input() routes: any[];
    public menuItems: any[];
    public showSidebar = false;

    ///////**************** */
    public serviceReturned = false;

    ngOnInit() {
        var value = sessionStorage.getItem("LoggedInRoleId");
        this.setModuleVisibility(value);

        ///////**************** */
        this.showSidebar = false;

        this.modeulePerm.state$.subscribe((state) => {
            if (state && state.permission && state.permission.length > 0) {
                var perms: ModulePermissionElement[] = state.permission;
                this.appitems.forEach(element => {
                    perms.forEach(perm => {
                        if (perm.ModuleName.toLowerCase() == element.label.toLowerCase()) {
                            if (!perm.IsPermitted) {
                                element.hidden = true;
                            }
                        }
                    });
                    if (element.items && element.items.length > 0) {
                        element.items.forEach(subelem => {
                            perms.forEach(perm => {
                                if (perm.ModuleName.toLowerCase() == subelem.label.toLowerCase()) {
                                    if (!perm.IsPermitted) {
                                        subelem.hidden = true;
                                    }
                                }
                            });
                        });
                    }
                });
                this.showSidebar = true;
            }

        });
    }


    ngOnChanges() {
        this.menuItems = this.routes.filter(menuItem => menuItem);
    }

    setModuleVisibility(roleId) {

        this.userService.getAllRoleModuleMAPPINGData(roleId)
            .subscribe(
                (data) => {
                    this.modeulePerm.setModules(data);

                });

    }

    constructor(private router: Router, private modeulePerm: ModulePermissionStore, private userService: AppUserService) { }

    //////////////////////  2222222222222222

    appitems = [

        {
            label: 'Dashboard',
            link: '/admin/dashboard',
        },

        {
            label: 'My Profile',
            items: [
  
               {
                label: 'Edit My Profile',
                link: '/admin/user-registration',                
               },            
    
                   ]
        },                  
                
  
        {
            label: 'Productivities',
            items: [
             

                {
                    label: 'BillHead Entries',
                    link: '/admin/product-entries',
                   
                },

                {
                    label: 'Coupon Rule',
                    link: '/admin/pointscoupon-entries',
                     queryParams: { type: 'COUPON' } 
                },

                {
                    label: 'Earning Rule',
                    link: '/admin/pointscoupon-entries',
                     queryParams: { type: 'EARNINGPOINTS' } 
                },

                {
                    label: 'Redeem Rule',
                    link: '/admin/pointscoupon-entries',
                     queryParams: { type: 'REDEEMPOINTS' } 
                },  

                {
                   label: 'Ledger Privacy Setup',
                   link: '/admin/Ledgerprivacysetup',
                },
                                    

            ]
        },

        {
          label: 'Ledger Account',
          items: [

              {
                  label: 'Party Entries',
                  link: '/admin/accountledger-entries',
                  queryParams: { type: 'CUSTOMER', cat:1, ck_assomr:false, ck_dr:false, ck_demo:true },                 
              },
           
              {
                  label: 'Debtor Entries',
                  link: '/admin/accountledger-entries',
                  queryParams: { type: 'DEBTOR', cat:2, ck_assomr:false, ck_dr:false, ck_demo:true },                 
              },

              {
                  label: 'Creditor Entries',
                  link: '/admin/accountledger-entries',
                  queryParams: { type: 'CREDITOR', cat:3, ck_assomr:false, ck_dr:false, ck_demo:true }
              },

              {
                  label: 'Employee Entries',
                  link: '/admin/accountledger-entries',
                  queryParams: { type: 'EMPLOYEE', cat:4, ck_assomr:false, ck_dr:false, ck_demo:true }
              },

              {
                label: 'Doctor Entries',
                link: '/admin/accountledger-entries',
                queryParams: { type: 'HOSPITAL AND DOCTOR', cat:8, ck_assomr:false, ck_dr:true, ck_demo:true  }
              },
              {
                label: 'Associate Entries',
                link: '/admin/accountledger-entries',
                queryParams: { type: 'ASSOCIATE', cat:9, ck_assomr:true, ck_dr:false, ck_demo:true }
              },

              {
                label: 'Bank Entries',
                link: '/admin/accountledger-entries',
                queryParams: { type: 'BANK', cat:5, ck_assomr:false, ck_dr:false, ck_demo:false }
              },              
    
              {
                label: 'TPA/Insurance Entries',
                link: '/admin/accountledger-entries',
                queryParams: { type: 'INSURANCE ORG', cat:19, ck_assomr:false, ck_dr:false, ck_demo:false }
              }, 

              {
                  label: 'Expense Heads Entries',
                  link: '/admin/accountledger-entries',
                  queryParams: { type: 'EXPENSE', cat:7, ck_assomr:false, ck_dr:false, ck_demo:false }
              },

              {
                label: 'Income Heads Entries',
                link: '/admin/accountledger-entries',
                queryParams: { type: 'INCOME', cat:6, ck_assomr:false, ck_dr:false, ck_demo:false },
                //  hidden: false
              },

         

          ]
        },


        // {
        //   label: 'Manage Scheduling',
        //   items: [

           
        //       {
        //           label: 'Inquirer Entries',
        //           link: '/admin/activityevent-entries',
        //           queryParams: { type: 'INQUIRER', cat:10, ck_assomr:false, ck_dr:false, ck_demo:true }
        //       },

        //       {
        //           label: 'Appointment Entries',
        //           link: '/admin/activityevent-entries',
        //           queryParams: { type: 'APPOINTMENT', cat:11, ck_assomr:false, ck_dr:false, ck_demo:true }
        //       },

        //       {
        //           label: 'Queue Entries',
        //           link: '/admin/activityevent-entries',
        //           queryParams: { type: 'QUEUE', cat:12, ck_assomr:false, ck_dr:false, ck_demo:true }
        //       },
         

        //   ]
        // },
    
      
                
        {
            label: 'Loan',
            items: [

            
                {
                    label: 'Membership',
                    link: '/admin/loan-registration',
                    hidden: false
                },

                {
                    label: 'LifeCycle',
                    link: '/admin/loan-lifecycle',
                   
                },                  
                {
                    label: 'RePayment',
                    link: '/admin/loan-repayment',
                   
                },  

                // {
                //     label: 'Report',
                //     link: '/admin/loan-report',
                   
                // },

                {
                  label: 'Advanced Loan',
                  link: '/admin/entries-accountingbook',
                  queryParams: { type: 'LoanAdvanced' }               
                },                         
   
  
            ]
        },

         
        {
          label: 'Manage Purchase',
          items: [

        
            {
                  label: 'Purchase Entries',
                  link: '/admin/entries-accountingbook',
                  queryParams: { type: 'PurchaseRegister' }               
            },

            {
                    label: 'Purchase Search',
                    link: '/admin/statistics-bill',
                    queryParams: { type: 'PurchaseRegister' }  
            }, 

            {
                label: 'Purchase Payment',
                link: '/admin/PurchaseBookPayment',
            },

            {
                label: 'Report Stock',
                link: '/admin/statistics-stock',
            },

            {
                  label: 'Requisition Entries',
                  link: '/admin/entries-accountingbook',
                  queryParams: { type: 'RequisitionRegister' }               
            },

            {
                    label: 'Requisition Search',
                    link: '/admin/statistics-bill',
                    queryParams: { type: 'RequisitionRegister' }  
            }, 

           
          ]
        },

           
        {
            label: 'Manage Bill',
            items: [ 
              
                {
                  label: 'Bill Entries',
                  link: '/admin/entries-accountingbook',
                  queryParams: { type: 'SalesRegister' }               
                },

                {
                    label: 'Bill Search',
                    link: '/admin/statistics-bill',
                    queryParams: { type: 'SalesRegister' }  
                }, 
                
                {
                    label: 'Billing Address',
                    link: '/admin/consignor-registration',
                },
    
                {
                    label: 'Shipping Address',
                    link: '/admin/consignee-registration',
                },                
                           

                {
                    label: 'Report Deleted',
                    link: '/admin/statistics-deleted',
                },

               
                
            ]
        },

        {

            label: 'Day Book',
            items: [ 
           
              {
                  label: 'Daybook Entries',
                  link: '/admin/entries-accountingbook',
                  queryParams: { type: 'DayBookRegister' }               
              },

              {
                label: 'Daybook Statistics',
                link: '/admin/DaybookStatistics',
              },   

              {
                    label: 'Daybook Search',
                    link: '/admin/statistics-bill',
                    queryParams: { type: 'DayBookRegister' }  
              }, 
                                  
              
    
            ]
            
        },
        
        



        {
            label: 'Item 4',
            link: '/item-4',
            icon: 'star_rate',
            hidden: true
        }


    ];

    config = {
        paddingAtStart: true,
        classname: 'my-custom-class',
        fontColor: '#232b45',
        // listBackgroundColor: 'rgb(208, 241, 239)',
        //fontColor: 'rgb(0, 0, 0)',
        // backgroundColor: 'rgb(208, 241, 239)',
        //selectedListFontColor: 'red',

    };

    // selectedItem(data) {
    //     this.router.navigate([data.link]);
    //     console.log(data);
    // }


    selectedItem(event: any): void {
    if (event.link) {
        this.router.navigate([event.link], {
        queryParams: event.queryParams || {}
        });
    }
    }


}
